import React, { useMemo } from 'react';

import { uploadImageService } from '@mygpt/app';

export const useUploadImage = () => {
  const [loading, setLoading] = React.useState(false);

  const uploadImage = React.useCallback(async (params: Parameters<typeof uploadImageService>[0]) => {
    setLoading(true);
    return uploadImageService(params).finally(() => {
      setLoading(false);
    });
  }, []);

  return useMemo(() => ({ loading, uploadImage }), [loading, uploadImage]);
};
